import React from 'react';

const CardHeading = ({
  Icon,
  title,
  iconSize = '15',
  textClassName = '',
  onIconClick = () => { },
  parentClassName = ''
}) => {
  return (
    <div className={`flex items-center ${parentClassName}`}>
      {Icon && (
        <div
          className='bg-gray-100 p-[6px] flex items-center justify-center rounded-full me-2 cursor-pointer '
          onClick={onIconClick}
        >
          <Icon size={iconSize} className='text-iconC' />
        </div>
      )}
      <h3 className={`text-darkBg text-[14px] lg:text-[16px] xl:text-[18px] font-[600] ${textClassName}`}>{title}</h3>
    </div>
  );
};

export default CardHeading;
